import React from "react";
import moment from "moment-timezone";
import {
  Card as MUICard,
  CardContent,
  Grid,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { IoCaretUpSharp, IoCaretDownSharp } from "react-icons/io5";
import { PlayerCardImageUrl } from "../../constant/Environment";

const PlayerCardItem = ({ value, index, onRemove }) => {
  // Image
  let playerImage = "";
  if (value?.image) {
    playerImage = value?.image.includes("https://")
      ? value?.image
      : `${PlayerCardImageUrl}/${value?.image}`;
  } else {
    playerImage = `${PlayerCardImageUrl}/player/player.png`;
  }

  // Time label
  const betslip_time = moment(value?.event_time).format("MMM DD, h:mm A");

  return (
    <MUICard
      id="addplayer"
      sx={{
        position: "relative",
        borderRadius: 4, // ~16px
        mb: 1,
        border: "2px solid #2B537C", // navy-ish border
        backgroundColor: "#FFFFFF",
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
        // transition: "box-shadow 0.2s ease, transform 0.08s ease",
        // ":hover": {
        //   boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
        //   transform: "translateY(-1px)",
        // },
      }}
    >
      <CardContent sx={{ p: "10px", "&:last-child": { pb: "10px" } }}>
        <Grid container alignItems="center" className="row">
          <Grid className="col-3" item xs={2.5}>
            <img
              alt={value?.name}
              src={playerImage}
              style={{ width: 58, height: 58, objectFit: "cover", marginTop: "-15px" }}
            />
          </Grid>

          <Grid item xs={9.5} className="col-9 ps-0">
            <Grid container direction="column" rowGap={0.2}>
              {/* Row 1: name + delete */}
              <Grid item>
                <Grid container alignItems="center">
                  <Grid item xs style={{ flexGrow: "1", maxWidth: "100%" }}>
                    <Typography
                      sx={{ fontSize: 16, fontWeight: 700, color: "#C02640" }}
                    >
                      {value?.name}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <IconButton
                      aria-label="remove"
                      onClick={() => onRemove(index, value)}
                      sx={{ color: "#E43A17", p: 0.5 }}
                    >
                      <MdDeleteOutline />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>

              {/* Row 2: team/position + time */}
              <Grid item>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item>
                    {value?.game_type == 2 ? (
                      <Typography
                        sx={{ fontSize: 14, color: "#0D3862", fontWeight: 500 }}
                      >
                        {value?.single_event}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{ fontSize: 14, color: "#0D3862", fontWeight: 500 }}
                      >
                        <Box
                          component="span"
                          sx={{ color: "#E65100", fontWeight: 600 }}
                        >
                          {value?.position}
                        </Box>
                        <Box
                          component="span"
                          sx={{ color: "#0D3862", fontWeight: 400, mx: 0.5 }}
                        >
                          |
                        </Box>
                        <Box component="span" sx={{ fontWeight: 600 }}>
                          {value?.team === value?.teamHid
                            ? value?.teamHname
                            : value?.teamAname}
                          <Box
                            component="span"
                            sx={{ fontWeight: 400, mx: 0.5 }}
                          >
                            {value?.team === value?.teamHid ? "vs" : "@"}
                          </Box>
                          {value?.team === value?.teamHid
                            ? value?.teamAname
                            : value?.teamHname}
                        </Box>
                      </Typography>
                    )}
                  </Grid>
                  <Grid item>
                    <Typography
                      sx={{ fontSize: 13, color: "#0D3862", fontWeight: 500 }}
                    >
                      {betslip_time}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* Row 3: ERA + MORE/LESS */}
              <Grid item>
                <Grid container alignItems="center">
                  <Grid item xs style={{ flexGrow: "1", maxWidth: "100%" }}>
                    <Typography sx={{ fontSize: 15, color: "#0D3862" }}>
                      <Box
                        component="span"
                        sx={{
                          color: "#0D3862",
                          fontWeight: 600,
                          letterSpacing: 0.2,
                        }}
                      >
                        {value?.statAbv
                          ?.toLowerCase()
                          .replace(/^\w/, (c) => c.toUpperCase())}
                        :{" "}
                      </Box>
                      <Box
                        component="span"
                        sx={{ color: "#0D3862", fontWeight: 600, fontSize: 14 }}
                      >
                        {value?.points}{" "}({value?.multiplier}x)
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item>
                    {(value?.more || value?.less) && (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        {value?.more && (
                          <>
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 700,
                                color: "#0D3862",
                              }}
                            >
                              MORE
                            </Typography>
                            <IoCaretUpSharp size={18} color="#2ca34c" />
                          </>
                        )}
                        {value?.less && (
                          <>
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 700,
                                color: "#0D3862",
                              }}
                            >
                              LESS
                            </Typography>
                            <IoCaretDownSharp size={18} color="#d32f2f" />
                          </>
                        )}
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </MUICard>
  );
};

export default PlayerCardItem;
